import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

const ligne = { marginTop: 8 };

function ouiNon(v) {
  return v ? 'Oui' : 'Non';
}

function SitewebResume({ rapport }) {
  if (!rapport) {
    return (
      <Paper style={{ padding: 16 }}>
        <Typography>Aucun rapport a afficher.</Typography>
      </Paper>
    );
  }

  const ref = rapport.referenceVersion || {};
  const pre = rapport.validationsPreDeploiement || {};
  const exe = rapport.executionDeploiement || {};
  const post = rapport.validationsPostDeploiement || {};

  return (
    <Paper style={{ padding: 16 }}>
      <Typography variant="h6">Apercu avant validation</Typography>
      <Divider style={{ marginTop: 12, marginBottom: 12 }} />

      <Typography style={ligne}><strong>Environnement:</strong> {rapport.environnementCible}</Typography>
      <Typography style={ligne}><strong>Operateur:</strong> {rapport.operateur}</Typography>
      <Typography style={ligne}><strong>Branche:</strong> {ref.branche || 'N/A'}</Typography>
      <Typography style={ligne}><strong>Commit:</strong> {ref.commit || 'N/A'}</Typography>
      <Typography style={ligne}><strong>Version:</strong> {ref.version || 'N/A'}</Typography>

      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
      <Typography variant="subtitle1">Avant deploiement</Typography>
      <Typography style={ligne}>`.env.transfert` present: {ouiNon(pre.envTransfertPresent)}</Typography>
      <Typography style={ligne}>Secrets non versionnes: {ouiNon(pre.secretsNonVersionnes)}</Typography>
      <Typography style={ligne}>Dry-run execute: {ouiNon(pre.dryRunExecute)}</Typography>
      <Typography style={ligne}>Dry-run valide: {ouiNon(pre.dryRunValide)}</Typography>
      <Typography style={ligne}>Mode `controlled` confirme: {ouiNon(pre.modeControlledParDefaut)}</Typography>
      <Typography style={ligne}>TLS explicite: {ouiNon(pre.tlsExplicite)}</Typography>
      <Typography style={ligne}>SSL verify actif: {ouiNon(pre.sslVerifyActif)}</Typography>
      <Typography style={ligne}>`DEPLOY_DELETE` actif: {ouiNon(pre.deployDeleteActif)}</Typography>
      <Typography style={ligne}>Justification suppression: {pre.justificationDelete || 'Aucune'}</Typography>

      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
      <Typography variant="subtitle1">Pendant deploiement</Typography>
      <Typography style={ligne}>Commande: {exe.commandeExecution || 'N/A'}</Typography>
      <Typography style={ligne}>Mode execution: {exe.modeExecution || 'N/A'}</Typography>
      <Typography style={ligne}>Portee complete confirmee: {ouiNon(exe.fullScopeConfirme)}</Typography>
      <Typography style={ligne}>Suppressions revues: {ouiNon(exe.suppressionRevue)}</Typography>
      <Typography style={ligne}>Incidents: {exe.incidents || 'Aucun'}</Typography>

      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
      <Typography variant="subtitle1">Apres deploiement</Typography>
      <Typography style={ligne}>Pages cles OK: {ouiNon(post.pagesClesOk)}</Typography>
      <Typography style={ligne}>API critiques OK: {ouiNon(post.apiCritiquesOk)}</Typography>
      <Typography style={ligne}>Logs sans erreur critique: {ouiNon(post.logsOk)}</Typography>
      <Typography style={ligne}>Fichiers attendus presents: {ouiNon(post.fichiersPresentsOk)}</Typography>
      <Typography style={ligne}>Notes: {post.notes || 'Aucune'}</Typography>

      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
      <Typography style={ligne}><strong>Decision finale:</strong> {rapport.decisionFinale}</Typography>
      <Typography style={ligne}><strong>Commentaire:</strong> {rapport.commentaireDecision || 'Aucun'}</Typography>
    </Paper>
  );
}

export default SitewebResume;




// WEBPACK FOOTER //
// src/components/deploiementsSiteweb/SitewebResume.js